<app-program-initiation-header
  [name]="name"
  [allCarriers]="allCarriers"
  [accountMappings]="accountMappings"
  (updateSFMapping)="updateSFMapping.emit($event)"
/>
<section class="body">
  <app-program-initiation-filter
    class="filters"
    [initialFilters]="query"
    [filterOptions]="filterOptions"
    [accountNameSuggestions]="accountNameSuggestions"
    [showAll]="showAll"
    (filtersChange)="filtersChange.emit($event)"
    (accountNameSearch)="accountNameSearch.emit($event)"
    (showAllChange)="showAllChange.emit($event)"
  />
  <app-program-initiation-list
    class="list"
    [rows]="rows"
    [totalCount]="totalCount ?? 0"
    [page]="query.page"
    [pageSize]="query.pageSize"
    [sortBy]="query.sortBy"
    [sortDirection]="query.sortDirection"
    [loading]="!!loading"
    [emptyMessage]="emptyMessage ?? ''"
    [isSaving]="isSaving"
    [initiatingOppId]="initiatingOppId"
    (sortChange)="sortChange.emit($event)"
    (pageChange)="pageChange.emit($event)"
    (initiate)="initiate.emit($event)"
  />
</section>
